module.exports = __webpack_public_path__ + "img/349.bb2be5d3.png";